import { useCallback, useEffect, useRef } from 'react';

/*
 * "Can't perform a React state update on an unmounted component."
 *
 * Esse aviso aparecia em três componentes do chamado -- a busca de cliente, a
 * presença e o cronômetro -- e todos pelo mesmo motivo: eles pedem algo ao
 * servidor e guardam a resposta no estado. Quando a pessoa fecha o chamado
 * antes da resposta chegar, o `set...` roda num componente que já saiu da
 * tela. O React ignora (é no-op), mas o pedido fica pendurado e, se o
 * componente voltar, dá para ver o dado velho piscar.
 *
 * O jeito certo é cada chamada saber se ainda tem para quem responder. Este
 * gancho devolve essa pergunta: `estouMontado()` antes de gravar estado
 * depois de um `await`.
 *
 * Não serve para cancelar o pedido em si (isso é `AbortController`, e a
 * camada de `http` não expõe) -- serve para não gravar o que não interessa
 * mais.
 */
export default function useEstouMontado() {
    const montado = useRef(true);

    useEffect(() => {
        montado.current = true;

        return () => {
            montado.current = false;
        };
    }, []);

    return useCallback(() => montado.current, []);
}
